export const CURRENCY = "PKR";
